function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "url(#social-instagram_svg__paint0_linear_931_7363)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 9.01c-4.505 0-8.784-.4-10.418 3.79-.675 1.732-.577 3.98-.577 7.198 0 2.825-.09 5.48.577 7.197 1.63 4.193 5.944 3.791 10.416 3.791 4.314 0 8.763.45 10.417-3.791.676-1.748.577-3.963.577-7.197 0-4.292.237-7.063-1.847-9.144-2.109-2.107-4.962-1.843-9.15-1.843H20zm-.985 1.98c9.398-.014 10.595-1.058 9.934 13.445-.234 5.13-4.143 4.566-8.948 4.566-8.76 0-9.012-.25-9.012-9.008 0-8.858.695-8.997 8.026-9.005v.003zm6.855 1.825a1.319 1.319 0 10-.001 2.637 1.319 1.319 0 000-2.637zM20 14.355a5.645 5.645 0 00-5.646 5.643A5.644 5.644 0 0020 25.64a5.642 5.642 0 100-11.284zm0 1.98c4.846 0 4.852 7.326 0 7.326-4.844 0-4.851-7.325 0-7.325z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "social-instagram_svg__paint0_linear_931_7363",
  x1: 2.686,
  y1: 37.394,
  x2: 39.748,
  y2: 5.31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF543E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C837AB"
})));

function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSocialInstagram;